<section class="downloads-section" *ngIf="documentList.length > 0">
  <h2 data-cy="product-detail.download-text">
    {{ 'i18n.productDetail.downloads.download' | translate }}
  </h2>
  <section class="button-list-section">
    <ng-container *ngFor="let document of documentList">
      <ion-button
        [ngClass]="{ 'disable-outline-button': document.disable }"
        [disabled]="document.disable"
        (click)="openFile(document.url)"
        [attr.data-cy]="
          'product-detail.download-disable-outline-' +
          document.label +
          '-button'
        "
      >
        <ion-icon
          name="arrow-down-circle-outline"
          data-cy="product-detail.download-disable-outline-button-icon"
        ></ion-icon>
        <label
          [attr.data-cy]="
            'product-detail.download-document-label' + document.label + '-text'
          "
        >
          {{ document?.label | translate }}
        </label>
      </ion-button>
    </ng-container>
  </section>
</section>
